import { observer } from 'mobx-react-lite';
import {
  RichTextField,
  TextField,
  Widget,
  WidgetHeader,
  WidgetProps,
} from '../../../../../components';
import Product from '../../../store/Product';

export default observer(function BeforeInstallWidget({
  product,
  ...rest
}: {
  product: Product;
} & Omit<WidgetProps, 'title'>) {
  const { beforeInstall } = product.extendedFeatures;

  const versions = product.versions?.getMatchedVersionsString(
    beforeInstall.version,
  );

  return (
    <Widget surface="gray" {...rest}>
      <WidgetHeader title="Show Message Before Install" />
      <TextField
        errorText={beforeInstall.errors.version}
        InputLabelProps={{ shrink: true }}
        label="Title"
        name="title"
        onBlur={beforeInstall.handleBlur}
        onChange={beforeInstall.handleChange}
        placeholder="Click OK to continue"
        value={beforeInstall.title}
      />
      <RichTextField
        label="Message"
        name="message"
        onChange={beforeInstall.handleChange}
        required
        value={beforeInstall.message}
      />
      <TextField
        errorText={beforeInstall.errors.version}
        InputLabelProps={{ shrink: true }}
        label="OK Text"
        name="okText"
        onBlur={beforeInstall.handleBlur}
        onChange={beforeInstall.handleChange}
        placeholder="OK"
        value={beforeInstall.okText}
      />
      <TextField
        errorText={beforeInstall.errors.version}
        helperText={`Affected versions: ${versions}. Examples: '1.0.9', '<2', '*'`}
        label="Run only for product versions"
        name="version"
        onBlur={beforeInstall.handleBlur}
        onChange={beforeInstall.handleChange}
        placeholder="Leave empty to apply to all versions"
        value={beforeInstall.version}
      />
    </Widget>
  );
});
